<template>
  <div class="app-container login-page">
    <HeaderLogo />
    <div class="login-main">
      <div class="login-card">
        <h2 class="login-title">{{ isRegister ? '注册账号' : '校园宿舍管理系统' }}</h2>
        <p class="login-subtitle">{{ isRegister ? '创建一个新账号' : '账号登录' }}</p>

        <!-- 登录表单 -->
        <div v-if="!isRegister">
          <div class="form-item">
            <label>账号</label>
            <input
              v-model="username"
              type="text"
              placeholder="请输入账号"
              @keyup.enter="handleLogin"
            />
          </div>
          <div class="form-item">
            <label>密码</label>
            <input
              v-model="password"
              type="password"
              placeholder="请输入密码"
              @keyup.enter="handleLogin"
            />
          </div>
          <div class="error" v-if="errorMsg">
            {{ errorMsg }}
          </div>
          <button class="btn btn-primary login-btn" @click="handleLogin">
            登录
          </button>
          <p class="hint">
            演示账号：<strong>admin</strong> / <strong>123456</strong>
          </p>
        </div>

        <!-- 注册表单 -->
        <div v-if="isRegister">
          <div class="form-item">
            <label>组织ID</label>
            <input
              v-model="registerId"
              type="text"
              placeholder="请输入组织ID"
            />
          </div>
          <div class="form-item">
            <label>账号</label>
            <input
              v-model="registerUsername"
              type="text"
              placeholder="请输入账号"
            />
          </div>
          <div class="form-item">
            <label>密码</label>
            <input
              v-model="registerPassword"
              type="password"
              placeholder="请输入密码"
            />
          </div>
          <div class="form-item">
            <label>确认密码</label>
            <input
              v-model="confirmPassword"
              type="password"
              placeholder="请确认密码"
            />
          </div>
          <div class="error" v-if="registerErrorMsg">
            {{ registerErrorMsg }}
          </div>
          <button class="btn btn-primary login-btn" @click="handleRegister">
            注册
          </button>
        </div>

        <div class="switch-section">
          <p class="switch-text">
            {{ isRegister ? '已有账号？' : '没有账号？' }}
            <a @click="toggleForm">{{ isRegister ? '登录' : '注册' }}</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus'
import HeaderLogo from '@/components/HeaderLogo.vue'
import { loginApi,registerApi } from '@/api/api'
const FIXED_USERNAME = 'admin'
const FIXED_PASSWORD = '123456'

export default {
  name: 'Login',
  components: { HeaderLogo },
  data() {
    return {
      username: '',
      password: '',
      errorMsg: '',
      isRegister: false, // 控制是否显示注册界面
      registerId: '',     // 注册时的ID字段
      registerUsername: '',
      registerPassword: '',
      confirmPassword: '',
      registerErrorMsg: ''
    }
  },
  methods: {
    async handleLogin() {
      this.errorMsg = ''
      if (!this.username || !this.password) {
        this.errorMsg = '请输入账号和密码'
        return
      }
      const form = {}
      form.account = this.username
      form.password = this.password
      
      const res = await loginApi(form)
      if(res.code == 0){
       await localStorage.setItem('token', res.data.token)
       EventBus.$emit('login-success',res.data.token)
       this.$router.replace({ name: 'DormGroup' })
      }else{
        this.errorMsg  = res.message
      }
     
    },
    async  handleRegister() {
      this.registerErrorMsg = ''
      if (!this.registerId || !this.registerUsername || !this.registerPassword || !this.confirmPassword) {
        this.registerErrorMsg = '请填写完整的注册信息'
        return
      }
      if (this.registerPassword !== this.confirmPassword) {
        this.registerErrorMsg = '两次密码输入不一致'
        return
      }

      const form = {}
      form.groupId=this.registerId
      form.account=this.registerUsername
      form.password=this.registerPassword
      form.confirmPassword=this.confirmPassword
      const res = await registerApi(form)
     
      if(res.code === 0){
        this.isRegister = false 
        this.registerId = ''
        this.registerUsername = ''
        this.registerPassword = ''
        this.confirmPassword = ''
      }else{
        this.registerErrorMsg = res.message
      }
      
    },

    toggleForm() {
      this.isRegister = !this.isRegister
      this.registerErrorMsg = '' // 切换表单时清除错误信息
    }
  }
}
</script>

<style scoped>
.login-page {
  background: transparent;
}

.login-main {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px 32px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: radial-gradient(circle at 0% 0%, #020617 0, #111827 70%);
  border-radius: 16px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.9);
  padding: 26px 28px 30px;
  border: 1px solid rgba(75, 85, 99, 0.8);
}

.login-title {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 6px;
  color: #f9fafb;
}

.login-subtitle {
  font-size: 13px;
  color: #9ca3af;
  text-align: center;
  margin-bottom: 20px;
}

.form-item {
  margin-bottom: 16px;
}

.form-item label {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
  color: #d1d5db;
}

.form-item input {
  width: 100%;
}

.error {
  color: #fecaca;
  font-size: 13px;
  margin-bottom: 10px;
}

.login-btn {
  width: 100%;
  margin-top: 4px;
}

.hint {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 12px;
  text-align: center;
}

.switch-section {
  margin-top: 20px;
  text-align: center;
}

.switch-text {
  font-size: 12px;
  color: #9ca3af;
}

.switch-text a {
  color: #60a5fa;
  cursor: pointer;
}

@media (max-width: 600px) {
  .login-card {
    padding: 22px 18px 24px;
  }
  .login-title {
    font-size: 20px;
  }
}
</style>
